<style lang="stylus">
    .displayarea
        width 100%
        height 300px
        margin-top 24px
        position relative
        border-radius 5px
        background var(--bg-color-tertiary)
        overflow auto

        .drag-modal
            width 300px
            .modal-font
                text-indent 6px
                font-size 14px
                margin-top 6px
        textarea
            position relative
            width 1200px
            height 500px

        #rightclick
            box-shadow 0 1px 1px #ccc, 1px 0 1px #ccc
            //border 1px solid gray
            //background-color #fff
            border 0
            z-index 999
            position fixed /*自定义菜单相对与body元素进行定位*/
            padding -5px

            .menu
                //background-color #fff
                padding-left 20px
                border 0
                width 130px
                height 25px
                line-height 25px

            .menu:hover
                background-color var(--bg-color-math-display-area-rightclick-hover)
                //margin-left -20px
                //padding-left 20px
                //margin-right 20px
</style>

<i18n>
{
  "zh": {
    "tips": {
      "fileParseErr": "文件解析失败",
      "fileParseSucc": "文件解析成功",
      "fileLoadErr": "文件载入失败",
      "fileLoadSucc": "文件载入成功"
    },
    "saveImgAs": "图片另存为",
    "saveCurrent": "是否保存当前编辑的公式"
  },
  "en": {
    "tips": {
      "fileParseErr": "File Parsing Failed",
      "fileParseSucc": "File Parsing Successfully",
      "fileLoadErr": "File Loading Failed",
      "fileLoadSucc": "File Loading Successfully"
    },
    "saveImgAs": "Save Image As",
    "saveCurrent": "Confirmed to save the current formula?"
  },
  "jp": {
    "tips": {
      "fileParseErr": "ファイルの解析に失敗しました",
      "fileParseSucc": "ファイルが正常に解析されました",
      "fileLoadErr": "ファイルの読み込みに失敗しました",
      "fileLoadSucc": "ファイルの読み込みに成功しました"
    },
    "saveImgAs": "画像に名前を付けて保存",
    "saveCurrent": "編集されている公式を保存しますか"
  },
  "fr": {
    "tips": {
      "fileParseErr": "Échec de l'analyse du fichier",
      "fileParseSucc": "Fichier analysé avec succès",
      "fileLoadErr": "Échec du chargement du fichier",
      "fileLoadSucc": "Chargement du fichier réussi"
    },
    "saveImgAs": "Enregistrer l'image sous",
    "saveCurrent": "Confirmé pour sauver la formule actuelle?"
  },
  "de": {
    "tips": {
      "fileParseErr": "Dateianalyse fehlgeschlagen",
      "fileParseSucc": "Dateianalyse erfolgreich",
      "fileLoadErr": "Dateispeichern fehlgeschlagen",
      "fileLoadSucc": "Dateispeichern erfolgreich"
    },
    "saveImgAs": "Bild speichern als",
    "saveCurrent": "Aktuelles Formular speichern?"
  },
  "es": {
    "tips": {
      "fileParseErr": "Análisis de archivos fallido",
      "fileParseSucc": "Análisis de archivos con éxito",
      "fileLoadErr": "Fallo en la carga de archivos",
      "fileLoadSucc": "Carga de archivos con éxito"
    },
    "saveImgAs": "Guardar imagen como",
    "saveCurrent": "¿Confirmado para guardar la fórmula actual?"
  },
  "pt": {
    "tips": {
      "fileParseErr": "Análise do Ficheiro Falhada",
      "fileParseSucc": "Análise do Ficheiro feita com Sucesso",
      "fileLoadErr": "Carregamento do Ficheiro Falhado",
      "fileLoadSucc": "Carregamento do Ficheiro feito com Sucesso"
    },
    "saveImgAs": "Gravar Imagem Como",
    "saveCurrent": "Confirmar para gravar a fórmula atual?"
  },
  "it": {
    "tips": {
      "fileParseErr": "Analisi del File Fallita",
      "fileParseSucc": "Analisi del File Completata con Successo",
      "fileLoadErr": "Caricamento del File Fallito",
      "fileLoadSucc": "Caricamento del File Completato con Successo"
    },
    "saveImgAs": "Salva Immagine Come",
    "saveCurrent": "Confermi di voler salvare la formula corrente?"
  },
  "tw": {
    "tips": {
      "fileParseErr": "檔案解析失敗",
      "fileParseSucc": "檔案解析成功",
      "fileLoadErr": "檔案載入失敗",
      "fileLoadSucc": "檔案載入成功"
    },
    "saveImgAs": "圖片另存新檔",
    "saveCurrent": "是否儲存當前編輯的公式"
  },
  "kr": {
    "tips": {
      "fileParseErr": "파일 구문 분석 실패",
      "fileParseSucc": "파일 구문 분석 성공",
      "fileLoadErr": "파일 로드 실패",
      "fileLoadSucc": "파일 로드 성공"
    },
    "saveImgAs": "다른 이름으로 이미지 저장",
    "saveCurrent": "현재 공식을 저장하시겠습니까?"
  }
}
</i18n>

<template>
    <div class="displayarea" ref="disArea">
        <!-- zoom是调整字体大小的滚动组件 -->
        <zoom :value="value" @setValue="getValue"></zoom>
        <!-- 当用户拖拽文件进来时调用此Modal -->
        <Dialog v-if="modal1" @ok="ok" @close="cancel" class="drag-modal" :extra="true" :title="'tip'" :showFooter="true">
            <p class="modal-font">{{ $t("saveCurrent") }}</p>
        </Dialog>
        <!-- 暂时没vip,暂时注释
        <Modal v-model="tipsShow" width="300" title="提示">
            <p>购买vip后解锁保存图片功能</p>
        </Modal> -->
        <!-- 当用户右键编辑区时展示保存图片菜单 -->
        <div id="rightclick" v-show="isShowRightClick">
            <div class="menu" @click="saveImg">{{ $t("saveImgAs") }}...</div>
            <!-- <div class="menu" @click="copyImg">
                复制图片
            </div> -->
        </div>
    </div>
</template>

<script>
    import zoom from "./zoom.vue";
    import saveAs from "./saveAs.vue";
    import Dialog from "../../Modals/Dialog.vue";
    export default {
        name: "",
        components: { zoom, Dialog },
        inject: ["EDMathUI"],
        data() {
            return {
                value: 40,
                modal1: false,
                fileData: "",
                isgbk: false,
                file: "",
                tipsShow: false,
                isShowRightClick: false,
            };
        },
        computed: {},
        methods: {
            // Modal组件点击确认后
            ok() {
                // this.$Message.info("请点击上面的保存按钮进行保存");
                // this.file = "";
                // this.fileData = "";
                // this.$emit("setSave", true);
                this.$bus.$emit("setSave");
                this.file = "";
                this.fileData = "";
                this.modal1 = false;
            },
            // Modal组件点击取消后
            cancel() {
                if (this.isgbk) {
                    var reader = new FileReader();
                    reader.readAsText(this.file, "gbk"); //发起异步请求
                    reader.addEventListener("load", (e) => {
                        try {
                            if (e.target.result) {
                                this.EDMathUI.view.openMml(e.target.result);
                                this.$edMessage.success(this.$t("tips.fileParseSucc"));
                            }
                        } catch (err) {
                            this.$edMessage.error(this.$t("tips.fileParseErr"));
                        }
                    });
                } else {
                    let isSuccess = this.EDMathUI.view.openMml(this.fileData);
                    isSuccess ? this.$edMessage.success(this.$t("tips.fileLoadSucc")) : this.$edMessage.error(this.$t("tips.fileLoadErr"));
                }
                this.file = "";
                this.fileData = "";
                this.modal1 = false;
            },
            getValue(val) {
                this.value = val;
                this.EDMathUI.view.fontSize = this.value;
            },
            dataURLtoBlob(img) {
                var arr = img.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            saveImg() {
                if (!this.$store.state.isVip && !this.$store.state.ui.nolimitMath) {
                    this.tipsShow = true;
                    return;
                }
                // let img = this.EDMathUI.view.outputPngURL();
                // let blob = this.dataURLtoBlob(img);
                // saveAs(blob, "IMG文件.png");
                // this.isSave = true;
                this.EDMathUI.view.outputPng("EdrawMath");
            },
            copyImg() {
                // this.EDMathUI.view.editCopy(1);

                // console.log("hello");
                // var clipboard = new ClipboardJS(".btn", {
                //     target: function(trigger) {
                //         return trigger.nextElementSibling;
                //     }
                // });
                // var div = document.createElement("div");
                // var img = document.createElement("img");
                // img.src = this.EDMathUI.view.outputPngURL();
                // // span.id = "bar";
                // div.appendChild(img);
                // div.contenteditable = true;
                // div.select();
                // console.log("succeed imgcopy");
                // return true;
                this.EDMathUI.view.editCopy(1);
            },
        },
        mounted() {
            // 接受zoom组件
            // this.copyImg();
            let obj = this.$refs.disArea;
            this.$bus.$on("fontSizeSet", (fontSize) => {
                this.value = fontSize;
            });
            this.$bus.$on("focusMathEditor", () => {
                setTimeout(() => {
                    document.getElementById("edta4Math").focus();
                }, 0);
            });
            obj.addEventListener("dragover", function (e) {
                e.preventDefault();
            });
            //用户右键事件
            obj.addEventListener("contextmenu", (e) => {
                e.preventDefault();
                let rightclick = document.getElementById("rightclick");
                this.isShowRightClick = true;
                rightclick.style.left = e.clientX + 2 + "px";
                rightclick.style.top = e.clientY + 2 + "px";

                // alert("hello");
            });
            // 用户拖拽文件的drop事件
            obj.addEventListener("drop", (e) => {
                e.preventDefault();
                let files = e.dataTransfer.files[0];
                this.file = files;
                var reader = new FileReader();
                if (this.file && reader) {
                    reader.readAsText(files, "utf-8"); //发起异步请求
                    reader.addEventListener("load", (e) => {
                        try {
                            if (e.target.result) {
                                this.fileData = e.target.result;
                                this.isgbk = false;
                                for (var _i = 0, text_1 = this.fileData; _i < text_1.length; _i++) {
                                    var c = text_1[_i];
                                    if (c.charCodeAt(0) == 65533) {
                                        this.isgbk = true;
                                        break;
                                    }
                                    if (c.charCodeAt(0) > 20000) {
                                        break;
                                    }
                                }
                                this.modal1 = true;
                                //this.EDMathUI.view.openMml(e.target.result);
                            }
                        } catch (err) {
                            this.$edMessage.error(this.$t("tips.fileParseErr"));
                        }
                    });
                }
            });
            //兼容IE,Opera,Chrome的鼠标滚动事件，用户可以Ctrl+鼠标滚轮改变编辑区字体大小
            let zoomFunc = (event) => {
                event.stopPropagation();
                let ctrlKey = EDView.osInfo.platform === "Mac" ? event.metaKey : event.ctrlKey;
                if (ctrlKey) {
                    if (event.wheelDelta) {
                        event.preventDefault();
                        let temValue = parseFloat(this.EDMathUI.view.fontSize);
                        if (event.wheelDelta > 0) {
                            temValue >= 198 ? (temValue = 200) : (temValue += 2);
                        } else {
                            temValue <= 14 ? (temValue = 12) : (temValue -= 2);
                        }
                        this.EDMathUI.view.fontSize = temValue;
                    } else if (event.detail) {
                        e.preventDefault();
                        let temValue = parseFloat(this.EDMathUI.view.fontSize);
                        if (e.detail < 0) {
                            temValue >= 98 ? (temValue = 100) : (temValue += 2);
                        } else {
                            temValue <= 14 ? (temValue = 12) : (temValue -= 2);
                        }
                        this.EDMathUI.view.fontSize = temValue;
                    }
                }
            };
            obj.addEventListener("DOMMouseScroll", zoomFunc, { passive: false }); //firefox;
            obj.addEventListener("wheel", zoomFunc, { passive: false });
            //兼容Firefox的鼠标滚动事件，用户可以Ctrl+鼠标滚轮改变编辑区字体大小
            // obj.addEventListener("DOMMouseScroll", event => {
            //     let e = event ? event : window.event ? window.event : null;
            //     e.stopPropagation();
            //     if (e.detail && e.ctrlKey) {
            //         e.preventDefault();
            //         let temValue = parseFloat(this.EDMathUI.view.fontSize);
            //         if (e.detail < 0) {
            //             temValue >= 98 ? (temValue = 100) : (temValue += 2);
            //         } else {
            //             temValue <= 14 ? (temValue = 12) : (temValue -= 2);
            //         }
            //         this.EDMathUI.view.fontSize = temValue;
            //     }
            // });
            // 用户点击编辑区非canvas画布区域能让编辑内容获取到焦点,并取消右键点击菜单
            obj.addEventListener("click", (event) => {
                this.isShowRightClick = false;
                // TODO: 暗黑模式
                if (this.EDMathUI.view && event.target.className === "displayarea") this.EDMathUI.view.focus();
            });
            //设置编辑区的高度
            // this.$refs.disArea.style.height = window.screen.height * 0.52 + "px";
        },
        beforeDestroy() {
            this.$bus.$off("fontSizeSet");
        },
    };
</script>
